<template>
	<div>
		<table class="shadow-none border border-gray-100">
			<tbody>
				<tr>
					<td></td>
					<td class="p-2 border-l border-r" v-for="comp in comps" :key="comp.id">
						<div class="flex flex-col items-center justify-center">
							<div class="relative">
	                            <a :href="`#${comp.id}`">
	                                <img :src="comp.image.view_url" class="mx-auto w-28 h-28 object-cover rounded-md shadow-md">
	                            </a>
	                            <a href="#_" class="lightbox" :id="`${comp.id}`">
	                                <img :src="comp.image.view_url">
	                            </a>
	                            <div
	                                class="absolute top-1 right-1 flex items-center justify-center w-10 h-10 p-4 rounded-full shadow-lg font-medium text-base text-white"
	                                :class="comp.pivot.score_color">
	                                {{ comp.pivot.score }}
	                            </div>
	                        </div>

							<div class="mt-3 flex items-center">
	                            <div @click="toggleFavorite(comp)">
	                                <inline-svg
	                                    name="favorite"
	                                    classes="w-10 h-10 cursor-pointer"
	                                    :class="comp.pivot.is_favorite ? 'text-red-600 hover:text-red-700' : 'text-gray-300 hover:text-red-600'">
	                                </inline-svg>
	                            </div>

	                            <div @click="toggleRejected(comp)">
	                                <inline-svg                            
	                                    name="rejected"
	                                    classes="w-10 h-10 cursor-pointer"
	                                    :class="comp.pivot.is_rejected ? 'text-red-600 hover:text-red-700' : 'text-gray-300 hover:text-red-600'">
	                                </inline-svg>
	                            </div>
	                        </div>
						</div>
					</td>
				</tr>
				<tr>
					<td class="px-2 min-w-[10rem] font-semibold">Criteria</td>
					<td class="p-4 border-l border-r" v-for="(comp, index) in comps" :key="index">
						<div class="flex flex-col">
                            <a v-bind:href="comp.pivot.view_url" class="block text-center">
                                <p v-if="! isNegotiationMode" class="text-lg font-semibold">{{ comp.address_line_1 }}</p>
                                <p v-else class="text-lg font-semibold">Alternative Site #{{ index + 1 }}</p>
                                <p class="text-base">{{ comp.city }}, {{ comp.state }}</p>
                            </a>
						</div>
					</td>
				</tr>
				<tr>
					<td class="px-2 font-semibold">Available Sq. Ft.</td>
					<td class="p-2 border-l border-r" v-for="(comp, compIndex) in comps" :key="compIndex">
						{{ comp.available_square_footage | number }}
					</td>
				</tr>
				<tr>
					<td class="px-2 font-semibold">Total Sq. Ft.</td>
					<td class="p-2 border-l border-r" v-for="(comp, compIndex) in comps" :key="compIndex">
						{{ comp.total_square_footage | number }}
					</td>
				</tr>
				<tr>
					<td class="px-2 font-semibold">Avg Rent PSF</td>
					<td class="p-2 border-l border-r" v-for="(comp, compIndex) in comps" :key="compIndex">
						{{ formatCurrency(comp.avg_rent, 2) }}
					</td>
				</tr>
				<tr>
					<td class="px-2 font-semibold">Parking Ratio x/1K</td>
					<td class="p-2 border-l border-r" v-for="(comp, compIndex) in comps" :key="compIndex">
						{{ comp.parking_ratio || '-' }}
					</td>
				</tr>
				<tr v-for="(ksd, ksdIndex) in scenarioKsds" :key="ksdIndex">
					<td class="px-2 font-semibold">{{ ksd.driver }}</td>
					<td class="p-2 border-l border-r" v-for="(comp, compIndex) in comps" :key="compIndex">
						<div class="flex items-center justify-center">
							<svg class="w-6 h-6 text-yellow-400" v-for="i in getCompKSDScore(ksd, comp.pivot.id)" :key="i" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
						  		<path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
							</svg>
							<svg class="w-6 h-6 text-gray-300" v-for="i in (5-getCompKSDScore(ksd, comp.pivot.id))" :key="i" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
						  		<path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
							</svg>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import moment from 'moment';

  	export default {
	    data() {
			return {
	        
			}
	    },
        
        computed: {
            ...mapState(['projects', 'projectComps']),
            ...mapGetters(['scenario', 'scenarioKsds']),

            comps() {
            	return _.take(this.projectComps.all, 4);
            },

            isNegotiationMode() {
                return this.scenario.negotiation_mode;
            },
        },

	    methods: {
            toggleFavorite(comp) {
                const favorited_at = comp.pivot.is_favorite ? null : moment().format('Y-MM-D H:m:ss');
                const favorited_by = comp.pivot.is_favorite ? null : window.user.id;

                comp.pivot.favorited_at = favorited_at;
                comp.pivot.favorited_by = favorited_by;
                comp.pivot.is_favorite = favorited_at ? true : false;

                this.updateComp(comp.pivot.id, {
                    favorited_at: favorited_at,
                    favorited_by: favorited_by
                });
            },

            toggleRejected(comp) {
                const rejected_at = comp.pivot.is_rejected ? null : moment().format('Y-MM-D H:m:ss');
                const rejected_by = comp.pivot.is_rejected ? null : window.user.id;

                comp.pivot.rejected_at = rejected_at;
                comp.pivot.rejected_by = rejected_by;
                comp.pivot.is_rejected = rejected_at ? true : false;

                this.updateComp(comp.pivot.id, {
                    rejected_at: rejected_at,
                    rejected_by: rejected_by
                });
            },

            updateComp(compId, params) {
                axios.patch('/projects/' + this.projects.selectedProject.id + '/comps/' + compId, params)
                    .then((response) => {
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        }); 
                    }).catch((response) => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: response.data.message
                        }); 
                    });
            },

            getCompKSDScore(ksd, compId) {
            	return _.find(ksd.scores, { 'scorable_id': compId })?.score || 0;
            }
		},
	}
</script>